import React, {useEffect, useState} from "react";
import Api from "../../../Api";
import Loading from "../../common/loading/loading";

const VenueFilter = (props) => {

    const [venueData, setVenueData] = useState({
        isLoading: true,
        terms: [],
        selectedIds: []
    });


    useEffect(() => {
        loadVenues();
    }, []);

    function loadVenues() {
        // Get the Data from the API
        let userToken = '';
        Api.getData(process.env.REACT_APP_API_URL + `frontend/getvenues`, userToken)
            .then(data => {
                if (data !== undefined) {
                    // Store the data from the API. below is an example
                    setVenueData({...venueData,
                        isLoading: false,
                        venues: data
                    });
                } else {
                    console.log('failed to load venues. Data is undefined.');
                    console.log(data);
                }
            })
            .catch(error => {
                console.log('failed to load classes');
                console.log(error);
            });
    }

    function handleFilterClick(key,value) {

        if (venueData.selectedIds.filter(x => x === value).length === 0) {
            // add
            setVenueData({
                ...venueData,
                selectedIds: [...venueData.selectedIds.filter(x => x !== value), value]
            });
        } else {
            // remove
            setVenueData({
                ...venueData,
                selectedIds: [...venueData.selectedIds.filter(x => x !== value)]
            });
        }
        props.OnSearch(key,value);

    }

    return  <div className="venue-filter filter">
            <h3>Venues</h3>
            {(!venueData.isLoading)? (
                <>
                    {(venueData.venues !== null &&  venueData.venues.length > 0) ?(
                        <ul>
                            {(venueData.venues.map(venueItem => (

                                <li className={"venue-name"} key={venueItem.venueId} onClick={()=>{ handleFilterClick("venue", venueItem.venueId) }}>

                                    {(venueData.selectedIds.filter(x => x === venueItem.venueId).length === 0)? (
                                        <img src="/assets/images/unchecked.svg" alt=""/>
                                    ) : (
                                        <img src="/assets/images/checked.svg" alt=""/>
                                    )}

                                    <span>{venueItem.name}</span>
                                </li>

                            )))}
                        </ul>
                    ):(
                        <div>No venues found</div>
                    )
                    }
                </>
            ) : (
                <Loading />
            )}

        </div>;

}

export default VenueFilter;
